import { useQuery } from '@tanstack/react-query';
import { fetchEmployeeStats, EmployeeStatsResponse } from '../adapters/overviewAdapter';

export const useEmployeeOverview = () => {
  return useQuery<EmployeeStatsResponse, Error>({
    queryKey: ['dashboard', 'employee-overview'],
    queryFn: fetchEmployeeStats,
    refetchOnWindowFocus: false,
  });
};
